const credentials = {
 //qa
   apiUrl: 'https://qatourapi.concept3d.com/api/admin',
   tourApiUrl: 'https://qatourapi.concept3d.com/api',
   redirectUri: 'http://qaaccounts.concept3d.com/callback',
   accountsAPI: 'https://qaaccountsapi.concept3d.com/api',
   transitAPI: 'https://qatransitbackend.concept3d.com',
   cmsURL: 'https://qacms.concept3d.com',
};
export default credentials;